import React from 'react'
import {CheckCircleFilled,CloseCircleFilled,InfoCircleFilled,WarningFilled} from '@ant-design/icons'
const Msg = ({type, text }:{ type:string,text: string }) => {
    return (<div className={'message'}>
        {type === 'success' && <CheckCircleFilled style={{color:'#52c41a'}}  />}
        {type === 'info' && <InfoCircleFilled style={{color:'#1890ff'}}   />}
        {type === 'error' && <CloseCircleFilled style={{color:'#ff4d4f'}}  />}
        {type === 'warning' && <WarningFilled style={{color:'#faad14'}}   />}
        <span style={{marginLeft:8}}>{text}</span>
    </div>
    )
}
export default Msg

  
  